import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Check } from 'lucide-react';
import ProductCard from '../components/payments/ProductCard';
import { STRIPE_PRODUCTS } from '../stripe-config';

export default function Pricing() {
  const resourceProduct = STRIPE_PRODUCTS.find(p => p.name === 'Resource Card');
  const jobSeekerProduct = STRIPE_PRODUCTS.find(p => p.name === 'Job seeker Card');

  return (
    <>
      <Helmet>
        <title>Pricing | RanchWorkUSA</title>
        <meta 
          name="description" 
          content="Simple, transparent pricing for RanchWorkUSA. Pay only for what you use."
        />
      </Helmet>

      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Simple Pricing
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              No subscriptions. Pay only when you create listings.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {/* Job Posting - Free */}
            <div className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 p-8">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Job Posting</h3>
                <div className="text-4xl font-bold text-green-600 mb-4">
                  FREE
                </div>
                <p className="text-gray-600">Post ranch job opportunities</p>
              </div>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-center text-gray-700">
                  <Check className="h-5 w-5 text-green-500 mr-3" />
                  Unlimited job postings
                </li>
                <li className="flex items-center text-gray-700">
                  <Check className="h-5 w-5 text-green-500 mr-3" />
                  Reach qualified candidates
                </li>
                <li className="flex items-center text-gray-700">
                  <Check className="h-5 w-5 text-green-500 mr-3" />
                  Email notifications
                </li>
              </ul>
            </div>

            {/* Job Seeker Profile */}
            {jobSeekerProduct && (
              <ProductCard
                product={jobSeekerProduct}
                features={[
                  'Professional profile page',
                  'Showcase skills & experience',
                  'Get discovered by employers',
                  'Apply to multiple jobs'
                ]}
                popular={true}
              />
            )}

            {/* Resource Listing */}
            {resourceProduct && (
              <ProductCard
                product={resourceProduct}
                features={[
                  'Sell or rent equipment',
                  'Photo uploads',
                  'Direct buyer contact',
                  'Increased visibility'
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}